"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBasedGatewayViewModel = void 0;
const GatewayBaseViewModel_1 = require("./GatewayBaseViewModel");
class EventBasedGatewayViewModel extends GatewayBaseViewModel_1.GatewayViewModel {
}
exports.EventBasedGatewayViewModel = EventBasedGatewayViewModel;
//# sourceMappingURL=EventBasedGatewayViewModel.js.map